'use strict';
import React from 'react';
import {Navigation} from 'react-router';
import t from 'tcomb-form';
import flux from 'utils/flux';
import email from 'email-validation';
import Select from 'react-select';
import dom from 'utils/dom';

const hasAccountGroupList = window.accountGroupList && window.accountGroupList.length;
const hasDepartmentList = window.departmentList && window.departmentList.length;

var Form = t.form.Form;
var Register = t.struct({
    firstName: t.Str,
    lastName: t.Str,
    email: t.subtype(t.Str, (s) => email.valid(s)),
    phoneNumber: t.Str,
    title: t.Str,
    company: t.Str,
    city: t.Str,
    zip: t.Str,
    state: t.Str,
    country: t.Str,
    password: t.Str,
    password_repeat: t.Str,
    account_group: hasAccountGroupList ? t.Str : t.Nil,
    department: hasDepartmentList ? t.maybe(t.Str) : t.Nil,
    comment: t.maybe(t.Str),
    acceptedTerms: t.subtype(t.Boolean, (s) => s === true),
    telephoneNumber: t.maybe(t.Str)
});

var RegisterModal = React.createClass({
    displayName: 'RegisterModal',
    mixins: [ Navigation ],
    propTypes: {
        hasError: React.PropTypes.oneOfType([
            React.PropTypes.string,
            React.PropTypes.bool
        ])
    },
    getInitialState() {
        return {
            firstName: '',
            lastName: '',
            email: '',
            phoneNumber: '',
            title: '',
            company: '',
            city: '',
            zip: '',
            state: '',
            country: false,
            password: '',
            password_repeat: '',
            account_group: '',
            department:'',
            comment: '',
            acceptedTerms: false,
            registerSuccess: false,
            submitting: false,
            telephoneNumber: ''
        };
    },
    _setInnerHtml(html) {
        return {__html: html};
    },
    componentWillReceiveProps(nextProps) {
        if (nextProps.hasError && this.state.submitting) {
            this.setState({submitting: false});
        }
    },
    onSubmit(evt) {
        evt.preventDefault();

        var registerData = this.refs.form.getValue();

        if ( registerData ) {
            this.setState({
                submitting: true
            });
            flux.getStore('app').registerUser(registerData)
            .then( () => {
                this.setState({
                    registerSuccess: true,
                    submitting: false
                });
            })
            .catch( error => {
                console.error( error );
            });
        }
    },
    renderError() {
        if (this.props.hasError) {
            return (
                <div className="content__error">
                    {this.props.hasError}
                </div>
            );
        }
    },
    onChange(value) {
        this.setState(value);
    },
    render() {
        const { acceptTermsCheckmark } = flux.getStore('app').getState().config.toJS();
        if (this.state.registerSuccess) {
            return (
                <div className="register__success">
                    <h4 className="form__success">
                        {flux.t('register_success_title')}
                    </h4>
                    {flux.t('register_success_message')}
                </div>
            );
        }

        var countryOptions = window.countryList.map((c) => {
            return {
                value: c.value,
                label: c.name
            };
        });

        var stateOptions = window.stateList.map((state) => {
            return {
                value: state,
                label: state
            };
        });

        var accountGroupOptions = ( window.accountGroupList && window.accountGroupList.map( option => {
            return {
                value: option.value,
                label: option.name
            };
        }) ) || [];

        var departmentOptions = ( window.departmentList && window.departmentList.map( option => {
            return {
                value: option.value,
                label: option.name
            };
        }) ) || [];

        var countryCode = this.state.country;
        var options = {
            auto: 'labels',
            template: locals => {
                const { inputs } = locals;
                return (
                    <div className="form__register">
                        <div className="register__left">
                            {inputs.firstName}
                            {inputs.lastName}
                            {inputs.email}
                            {inputs.title}
                            {inputs.company}
                            {inputs.telephoneNumber}
                        </div>
                        <div className="register__right">
                            {inputs.country}
                            {inputs.city}
                            <div className="register__state">
                                {inputs.zip}
                                {inputs.state}
                            </div>
                            {inputs.password}
                            {inputs.password_repeat}
                            {inputs.account_group}
                            {inputs.department}
                        </div>
                        <div className="register__tac">
                            <p className="text-light"
                               dangerouslySetInnerHTML={dom.setInnerHtml(flux.t('terms_and_conditions'))}/>
                            {acceptTermsCheckmark && inputs.acceptedTerms}
                        </div>
                        <span className="register__hint">{flux.t('register_required_fields_text')}</span>
                    </div>);
            },
            fields: {
                firstName: {
                    error: flux.t('validation_firstName'),
                    label: flux.t('register_firstname')
                },
                lastName: {
                    error: flux.t('validation_lastName'),
                    label: flux.t('register_lastname')
                },
                email: {
                    error: flux.t('validation_email'),
                    label: flux.t('register_email')
                },
                phoneNumber: {
                    error: flux.t('validation_phoneNumber'),
                    label: flux.t('register_phone')
                },
                telephoneNumber: {
                    error: flux.t('validation_telephoneNumber'),
                    label: flux.t('register_telephone')
                },
                title: {
                    error: flux.t('validation_title'),
                    label: flux.t('register_title')
                },
                company: {
                    error: flux.t('validation_company'),
                    label: flux.t('register_company')
                },
                city: {
                    error: flux.t('validation_city'),
                    label: flux.t('register_city')
                },
                zip: {
                    error: flux.t('validation_postcode'),
                    label: flux.t('register_postcode')
                },
                state: {
                    error: flux.t('validation_state'),
                    label: flux.t('register_state'),
                    template: function(locals) {
                        var stateInput;
                        if (!countryCode || countryCode === '') {
                            stateInput = (
                                <input type="text"
                                    value={flux.t('validation_country')}
                                    disabled='disabled' />);
                        } else if (countryCode !== 'US') {
                            var onChange = function(e) {
                                e.preventDefault();
                                locals.onChange(e.target.value);
                            };
                            stateInput = (
                                <input type="text"
                                    onChange={onChange}
                                    value={locals.value} />);
                        } else if (countryCode === 'US') {
                            stateInput = (<Select
                                name="state"
                                options={stateOptions}
                                value={locals.value}
                                onChange={locals.onChange}
                            />);
                        }

                        return (
                            <div className="field">
                                <label>{locals.label}</label>
                                {stateInput}
                                {locals.hasError ? <div className="field__error">{locals.error}</div> : ''}
                            </div>);
                    }
                },
                country: {
                    error: flux.t('validation_country'),
                    label: flux.t('register_country'),
                    template: function(locals) {
                        return (
                            <div className="field">
                                <label>{locals.label}</label>
                                <Select
                                    name="country"
                                    placeholder={flux.t('validation_country')}
                                    options={countryOptions}
                                    value={locals.value}
                                    onChange={locals.onChange}
                                />
                                {locals.hasError ? <div className="field__error">{locals.error}</div> : ''}
                            </div>
                        );
                    }
                },
                password: {
                    type: 'password',
                    error: flux.t('validation_password'),
                    label: flux.t('register_password')
                },
                password_repeat: {
                    type: 'password',
                    hasError: this.state.password !== this.state.password_repeat,
                    error: flux.t('validation_password_repeat'),
                    label: flux.t('register_password_repeat')
                },
                account_group: {
                    error: flux.t('validation_account_group'),
                    label: flux.t('register_account_group'),
                    template: locals => {
                        if ( !hasAccountGroupList ) {
                            return false;
                        }

                        return (
                            <div className="field">
                                <label>{locals.label}</label>
                                <Select
                                    name="account_group"
                                    placeholder={flux.t('validation_account_group')}
                                    options={accountGroupOptions}
                                    value={locals.value}
                                    onChange={locals.onChange}
                                />
                                {locals.hasError ? <div className="field__error">{locals.error}</div> : ''}
                            </div>
                        );
                    }
                },
                department: {
                    error: flux.t('validation_department'),
                    label: flux.t('register_department'),
                    template: locals => {
                        if ( !hasDepartmentList ) {
                            return false;
                        }

                        return (
                            <div className="field">
                                <label>{locals.label}</label>
                                <Select
                                    name="department"
                                    placeholder={flux.t('validation_department')}
                                    options={departmentOptions}
                                    value={locals.value}
                                    onChange={locals.onChange}
                                />
                                {locals.hasError ? <div className="field__error">{locals.error}</div> : ''}
                            </div>
                        );
                    }
                },
                comment: {
                    type: 'textarea',
                    label: flux.t('register_comment')
                },
                acceptedTerms: {
                    type: 'checkbox',
                    error: flux.t('validation_accepted_terms'),
                    label: flux.t('register_accepted_terms')
                },
            }
        };

        return (
            <div>
                <h4>{flux.t('account_sign_up')}</h4>
                <form onSubmit={this.onSubmit}>
                    <Form
                      ref="form"
                      type={Register}
                      value={this.state}
                      options={options}
                      onChange={this.onChange}
                    />
                    {this.renderError()}
                    <hr className="white" />
                    <div className="register__submit">
                        <button disabled={this.state.submitting} type="submit" className="btn btn-primary btn-arrow">
                            {flux.t('register_submit')}
                            <i className="gopro-chevron-right" />
                        </button>
                    </div>
                    <div className="mejs-clear" />
                </form>
            </div>
        );
    }
});

module.exports = RegisterModal;



// WEBPACK FOOTER //
// ./app/components/modals/registerModal.jsx